import React, { Component } from 'react';
import {Videoplayer} from '../../components/Videoplayer/Videoplayer.js'
import {t} from "../../lang/i18n.js";
import {darkMode} from '../../Utils.js';
import TitleLoop from '../../components/TitleLoop/TitleLoop.js'

import './Reels.scss'

export class Reels extends Component {

  constructor(props) {
    super(props);

    let darkMode = typeof this.props.content.custom_fields.dark_mode_template !== 'undefined' && this.props.content.custom_fields.dark_mode_template;

    this.state = { data: {}, network: true, darkMode: darkMode, seekVideo : 0 };

    //this.fetchPostData = this.fetchPostData.bind(this);
    this._highlightsNav = this.highlightsNav.bind(this)
  }

  componentDidMount() {
    darkMode(this.state.darkMode)
    this.setState({network: false});
  }

  componentDidUpdate() {

  }

  highlightsNav(e, seconds) {
    //this.setState({seekVideo: seconds});

    this.setState({
        seekVideo:seconds
    }, () => {
        this.setState({seekVideo:seconds + 1})
    })

  }

  render() {
    let title = this.props.content.title;
    let content = this.props.content.content;
    let highlights = this.props.content.custom_fields.reels_highlights;
    function minutesToSeconds(ms) {
      var a = ms.split(':');
      var seconds = (+a[0]) * 60 + (+a[1]);
      return seconds;
    }
    let reelURL = this.props.content.custom_fields.reel_url;
    let reelPreview = (this.props.content.custom_fields.reel_preview) ? this.props.content.custom_fields.reel_preview.url : false;


    if (!this.state.network) {
      return (
        <main>
          <section className="module module--reels module--ontop">
            <div className="module__inner">
              <header className="module__header">
                <div className="module__header__inner">
                  <h1 className="module__header__title ">
                    <TitleLoop title={title} />
                  </h1>
                </div>
              </header>

              <div className="module__body" data-scroll data-scroll-class="inview">
                <div className="module__body__inner">
                  <Videoplayer url={reelURL} preview={reelPreview} loop={true} goTo={this.state.seekVideo} controls={true} />
                  <div className="module__body__content">
                    <div className="module__body__content__inner">
                      <div className="module__body__content__section module__body__content__section--1">
                        <div className="htmlcontent htmlcontent--2" dangerouslySetInnerHTML={{__html: content}} />
                      </div>
                      <div className="module__body__content__section module__body__content__section--2">
                        {highlights &&
                          <>
                            <h2 className="title title--2">{t('highlights')}</h2>
                            <ul className="highlightlist">
                            {highlights.map((highlight, index) => {
                              return (
                                <li key={index} className="highlightlist__item">
                                  <button className={`highlightlist__item__button`} onClick={(e) => this._highlightsNav(e, minutesToSeconds(highlight.highlight_time))}>
                                    <span className="highlightlist__item__time">{highlight.highlight_time}</span>
                                    <span className="highlightlist__item__title">{highlight.highlight_title}</span>
                                  </button>
                                </li>
                              )
                            })}
                            </ul>
                          </>
                        }
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      )
    } else {
      return (
        <main>

        </main>
      )
    }
  }
}
